import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import React, { forwardRef, useMemo, cloneElement } from 'react';
import classNames from 'classnames';
import { useId } from '@andes/context';
import '@andes/common/build/utils/includes';
import _jsx from '@babel/runtime/helpers/jsx';
const DEPRECATED_BORDER_COLOR_DEFAULT = 'default';
const DEPRECATED_BORDER_COLOR_NEUTRAL = 'neutral';
const DEPRECATED_BORDER_COLOR_SUCCESS = 'success';
const DEPRECATED_BORDER_COLOR_ERROR = 'error';
const DEPRECATED_BORDER_COLOR_WARNING = 'warning';
const BORDER_COLOR_ACCENT = 'accent';
const BORDER_COLOR_GREEN = 'green';
const BORDER_COLOR_RED = 'red';
const BORDER_COLOR_ORANGE = 'orange';
const BORDER_COLOR_NONE = 'none';
const computeColor = color => {
  switch (color) {
    case DEPRECATED_BORDER_COLOR_DEFAULT:
      return undefined;
    case BORDER_COLOR_ACCENT:
    case DEPRECATED_BORDER_COLOR_NEUTRAL:
      return BORDER_COLOR_ACCENT;
    case BORDER_COLOR_RED:
    case DEPRECATED_BORDER_COLOR_ERROR:
      return BORDER_COLOR_RED;
    case BORDER_COLOR_ORANGE:
    case DEPRECATED_BORDER_COLOR_WARNING:
      return BORDER_COLOR_ORANGE;
    case BORDER_COLOR_GREEN:
    case DEPRECATED_BORDER_COLOR_SUCCESS:
      return BORDER_COLOR_GREEN;
    case BORDER_COLOR_NONE:
      return BORDER_COLOR_NONE;
    default:
      return undefined;
  }
};
var computeColor$1 = computeColor;
const DEPRECATED_PADDING_SIZE_DEFAULT = 'default';
const DEPRECATED_PADDING_SIZE_0 = '0';
const DEPRECATED_PADDING_SIZE_16 = '16';
const DEPRECATED_PADDING_SIZE_24 = '24';
const DEPRECATED_PADDING_SIZE_32 = '32';
const PADDING_SIZE_0 = 0;
const PADDING_SIZE_16 = 16;
const PADDING_SIZE_24 = 24;
const PADDING_SIZE_32 = 32;
const computePaddingSize = paddingSize => {
  switch (paddingSize) {
    case DEPRECATED_PADDING_SIZE_DEFAULT:
      return PADDING_SIZE_16;
    case DEPRECATED_PADDING_SIZE_0:
      return PADDING_SIZE_0;
    case DEPRECATED_PADDING_SIZE_16:
      return PADDING_SIZE_16;
    case DEPRECATED_PADDING_SIZE_24:
      return PADDING_SIZE_24;
    case DEPRECATED_PADDING_SIZE_32:
      return PADDING_SIZE_32;
    default:
      return paddingSize;
  }
};
var computePaddingSize$1 = computePaddingSize;
const cardNamespace = 'andes-card';
const cardSecondaryNamespace = "".concat(cardNamespace, "--secondary");
const cardHeaderNamespace = "".concat(cardNamespace, "__header");
const cardContentNamespace = "".concat(cardNamespace, "__content");
const cardFooterNamespace = "".concat(cardNamespace, "__footer");
const _excluded$1 = ["animated", "borderColor", "children", "className", "color", "component", "id", "paddingSize", "shadow"];
const Card = /*#__PURE__*/function () {
  const Card = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
        animated = false,
        borderColor: _willDeprecate$borderColor,
        children,
        className,
        color,
        component: Component = 'div',
        id,
        paddingSize = 16,
        shadow = 'flat'
      } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$1);
    const computedColor = useMemo(() => computeColor$1(color || _willDeprecate$borderColor), [color, _willDeprecate$borderColor]);
    const computedPaddingSize = useMemo(() => computePaddingSize$1(paddingSize), [paddingSize]);
    const componentId = useId(id);
    const isSecondaryColor = typeof computedColor === 'undefined' && typeof color !== 'undefined' && color !== DEPRECATED_BORDER_COLOR_DEFAULT;
    const setSecondaryColor = () => {
      if (!isSecondaryColor) return undefined;
      return {
        '--background-secondary-color': color
      };
    };
    const cardClassNames = classNames(cardNamespace, className, "".concat(cardNamespace, "--").concat(shadow), {
      ["".concat(cardNamespace, "--").concat(computedColor)]: computedColor,
      ["".concat(cardNamespace, "--padding-").concat(computedPaddingSize)]: typeof computedPaddingSize === 'number',
      ["".concat(cardNamespace, "--secondary-color")]: isSecondaryColor,
      ["".concat(cardNamespace, "--animated")]: animated
    });
    return /*#__PURE__*/React.createElement(Component, _extends({
      style: setSecondaryColor()
    }, props, {
      className: cardClassNames,
      id: componentId,
      ref: ref
    }), children);
  });
  Card.displayName = 'Card';
  return Card;
}();
var Card$1 = Card;
const CardSecondary = /*#__PURE__*/function () {
  const CardSecondary = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      background = 'light',
      children,
      className,
      component = 'div',
      id,
      paddingSize = 16
    } = _ref;
    const componentId = useId(id);
    const cardSecondaryClassnames = classNames(className, {
      ["".concat(cardSecondaryNamespace, "-").concat(background)]: background
    });
    return /*#__PURE__*/React.createElement(Card$1, {
      paddingSize: paddingSize,
      className: cardSecondaryClassnames,
      component: component,
      id: componentId,
      ref: ref
    }, children);
  });
  CardSecondary.displayName = 'CardSecondary';
  return CardSecondary;
}();
var CardSecondary$1 = CardSecondary;
const CardHeader = /*#__PURE__*/function () {
  const CardHeader = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      border,
      children,
      className,
      component: Component = 'div',
      showBorder = true
    } = _ref;
    const cardHeaderClassnames = classNames(cardHeaderNamespace, className, {
      ["".concat(cardHeaderNamespace, "--border")]: typeof border !== 'undefined' ? border : showBorder
    });
    return /*#__PURE__*/React.createElement(Component, {
      className: cardHeaderClassnames,
      ref: ref
    }, /*#__PURE__*/cloneElement(children, {
      className: "".concat(cardHeaderNamespace, "-title")
    }));
  });
  CardHeader.displayName = 'CardHeader';
  return CardHeader;
}();
var CardHeader$1 = CardHeader;
const CardContent = /*#__PURE__*/function () {
  const CardContent = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      children,
      className,
      component: Component = 'div'
    } = _ref;
    return /*#__PURE__*/React.createElement(Component, {
      className: classNames(cardContentNamespace, className),
      ref: ref
    }, children);
  });
  CardContent.displayName = 'CardContent';
  return CardContent;
}();
var CardContent$1 = CardContent;
const _excluded = ["href", "icon", "onClick", "text", "title"];
const CardFooter = /*#__PURE__*/function () {
  const CardFooter = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      border,
      children,
      className,
      component: Component = 'div',
      link = {},
      showBorder = true
    } = _ref;
    const hasLink = Object.keys(link).length > 0;
    const addShowBorderClass = typeof border !== 'undefined' ? border : showBorder;
    const cardFooterClassnames = classNames(cardFooterNamespace, className, {
      ["".concat(cardFooterNamespace, "--common")]: hasLink,
      ["".concat(cardFooterNamespace, "--border")]: addShowBorderClass
    });
    const {
        href,
        icon,
        onClick,
        text,
        title
      } = link,
      otherLinkProps = _objectWithoutProperties(link, _excluded);
    if (text) {
      if (href) {
        const linkRef = ref;
        const cardLinkActionClassNames = classNames(cardFooterClassnames, "".concat(cardFooterNamespace, "--link"));
        return /*#__PURE__*/React.createElement("a", _extends({
          href: href,
          className: cardLinkActionClassNames,
          onClick: onClick,
          title: title,
          ref: linkRef
        }, otherLinkProps), text, icon && /*#__PURE__*/_jsx("span", {
          className: "".concat(cardFooterNamespace, "-arrow")
        }));
      }
      if (onClick) {
        const cardButtonActionClassNames = classNames(cardFooterClassnames, "".concat(cardFooterNamespace, "--button"));
        const buttonRef = ref;
        const buttonProps = otherLinkProps;
        return /*#__PURE__*/React.createElement("button", _extends({
          className: cardButtonActionClassNames,
          onClick: onClick,
          ref: buttonRef
        }, buttonProps), text, icon && /*#__PURE__*/_jsx("span", {
          className: "".concat(cardFooterNamespace, "-arrow")
        }));
      }
    }
    return /*#__PURE__*/React.createElement(Component, {
      className: cardFooterClassnames,
      ref: ref
    }, children);
  });
  CardFooter.displayName = 'CardFooter';
  return CardFooter;
}();
var CardFooter$1 = CardFooter;
export { Card$1 as Card, CardContent$1 as CardContent, CardFooter$1 as CardFooter, CardHeader$1 as CardHeader, CardSecondary$1 as CardSecondary, Card$1 as default };
